import * as React from "react";
import { forwardRef } from "react";
const SvgIconSpainFlag = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, fill: "none", viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#DD2C00", d: "M0 1.75h14v10.497H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#FFC107", d: "M0 4.549h14v4.898H0z" }));
const ForwardRef = forwardRef(SvgIconSpainFlag);
export { ForwardRef as ReactComponent };
